import {NgModule, Pipe, PipeTransform} from '@angular/core';
import {Router} from "@angular/router";
declare let _: any;

@Pipe({
    name: 'parseUrl',
    standalone: false
})
export class ParseUrlPipe implements PipeTransform {

    constructor(protected router: Router) {}

    transform(url: any, type = 'url'): any {
        if(!url) return;
        switch (type){
            case 'url':
                return url.split('?')[0];
            case 'queryParams':
                return this.router.parseUrl(url).queryParams;
            case 'fragment':
                return this.router.parseUrl(url).fragment;
        }
    }
}

@NgModule({
    declarations: [ParseUrlPipe],
    exports: [ParseUrlPipe]
})
export class  ParseUrlPipeModule{}
